<template>
  <div>
    <Loading v-if="$asyncComputed.resource.updating" />
    <UserForm v-else :resource="resource" :destroy="destroy" :submit="submit" :cancel="cancel" />

    <Loading v-if="$asyncComputed.userRoles.updating" />
    <UserRoleForm v-else :user="resource" :user-roles="userRoles" :groups="groups" />
  </div>
</template>

<script>
import _ from 'lodash';

import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/users_service';
import UserRoleService from '@/services/resources/user_roles_service';
import SitesService from '@/services/resources/sites_service';
import ChemicalManufacturersService from '@/services/resources/chemical_manufacturers_service';

export default {
  mixins: [EditView],
  components: {
    UserForm: () => import('@/components/forms/UserForm.vue'),
    UserRoleForm: () => import('@/components/forms/UserRoleForm.vue'),
  },
  data() {
    return {
      urlFragment: 'users',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    userRoles: {
      get() {
        const filter = { user: this.resource.id };

        if (this.siteId) {
          filter.site = this.siteId;
        }

        return UserRoleService.index({
          filter,
          include: 'group,role',
        }).then((role) => {
          return role.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
    groups: {
      get() {
        if (this.siteId) {
          return SitesService.get(this.siteId).then((site) => {
            return [site.data];
          });
        }

        const promises = [SitesService, ChemicalManufacturersService].map((service) => {
          return service.index().then((groups) => {
            return groups.data;
          });
        });

        return Promise.all(promises).then((data) => {
          return _.flatten(data);
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
